import {
  MenuItem,
  MenuList,
  Paper,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { forwardRef, useImperativeHandle, useRef } from "react";

import { MentionTag } from "../../MentionTag";
import { SuggestionItem } from "./filter";

export type SuggestionsMenuVariant = "mention" | "autocomplete";

interface SuggestionsMenuProps {
  items: SuggestionItem[];
  command: (item: { id: string }) => void;
  variant?: SuggestionsMenuVariant;
}

export interface SuggestionsMenuHandle {
  focusOnFirstItem: () => void;
}

export const SuggestionsMenu = forwardRef<
  SuggestionsMenuHandle,
  SuggestionsMenuProps
>((props, ref) => {
  const { items, command, variant } = props;
  const isMention = variant === "mention";

  const firstItemRef = useRef<HTMLLIElement>(null);
  const menuListRef = useRef<HTMLUListElement>(null);

  useImperativeHandle(
    ref,
    () => ({
      focusOnFirstItem: () => firstItemRef.current?.focus(),
    }),
    [],
  );

  return (
    <Paper sx={{ opacity: 1 }}>
      <MenuList
        ref={menuListRef}
        sx={{
          maxHeight: 200,
          overflowY: "auto",
          maxWidth: 300,
        }}
      >
        {items.map((item, index) => (
          <Tooltip
            title={item.isNew ? `Add "${item.id}"` : item.id}
            arrow
            placement="right"
            key={`${item.id}-${index}`}
          >
            <MenuItem
              value={item.id}
              onClick={() => command({ id: item.id })}
              ref={index === 0 ? firstItemRef : undefined}
            >
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                maxWidth="100%"
              >
                {item.isNew && <Typography variant="small">Add</Typography>}
                {isMention ? (
                  <MentionTag variant="small">@{item.id}</MentionTag>
                ) : (
                  <Typography
                    variant="small"
                    noWrap
                    overflow="hidden"
                    textOverflow="ellipsis"
                  >
                    {item.id}
                  </Typography>
                )}
              </Stack>
            </MenuItem>
          </Tooltip>
        ))}
      </MenuList>
    </Paper>
  );
});
